import { Component, OnInit } from "@angular/core";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "download-section",
  templateUrl: "./app-download-section.component.html",
  styleUrls: [
    "./app-download-section.component.css",
    "../../app.component.css",
  ],
})
export class AppDownloadSectionComponent implements OnInit {
  config;
  constructor(private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {}
}
